import { Cancel } from '@mui/icons-material';
import CropIcon from '@mui/icons-material/Crop';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Slider,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import Cropper from 'react-easy-crop';
import getCroppedImg from './utils/cropImage';

const CropEasy = ({ photoURL, setOpenCrop, setPhotoURL, setFile, onCropComplete }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const cropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
    
  };

  const cropImage = async () => {
    try {
      const { file, url } = await getCroppedImg(
        photoURL,
        croppedAreaPixels,
        rotation
      );
      setPhotoURL(url);
      setFile(file);
      setOpenCrop(false);
      onCropComplete(file);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <DialogContent
        dividers
        sx={{
          position: 'relative',
          height: 500,
          width: 'auto',
          minWidth: { sm: 500 },
          borderTopLeftRadius: '8px', 
          borderTopRightRadius: '8px', 
          background: 'rgba(253, 152, 0, 0.2)'
        }}
      >
        
        <Cropper
          image={photoURL}
          crop={crop}
          zoom={zoom}
          rotation={rotation}
          aspect={316/260}
          onZoomChange={setZoom}
          onRotationChange={setRotation}
          onCropChange={setCrop}
          onCropComplete={cropComplete}
        />
      </DialogContent>
      <DialogActions sx={{background: 'rgba(241, 239, 236, 0.99)',  flexDirection: 'column', px: 3, py:4, borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',}}>
        <Box sx={{ width: '100%'}}>
          <Box>
            <Typography>Zoom</Typography>
            <Slider
              valueLabelDisplay="auto"
              min={1}
              max={3}
              step={0.01}
              value={zoom}
              onChange={(e, zoom) => setZoom(zoom)}
              sx={{
                color: '#DC5D00', // Cambia el color del slider
                '& .MuiSlider-thumb': { backgroundColor: '#DC5D00' }, 
                '& .MuiSlider-track': { backgroundColor: '#DC5D00' }, 
                '& .MuiSlider-rail': { backgroundColor: '#FFA066' }, 
              }}
            />
          </Box>
          <Box>
            <Typography>Rotation: {rotation + '°'}</Typography>
            <Slider
              valueLabelDisplay="auto"
              min={0}
              max={360}
              value={rotation}
              onChange={(e, rotation) => setRotation(rotation)}
              sx={{
                color: '#DC5D00', // Cambia el color del slider
                '& .MuiSlider-thumb': { backgroundColor: '#DC5D00' }, 
                '& .MuiSlider-track': { backgroundColor: '#DC5D00' }, 
                '& .MuiSlider-rail': { backgroundColor: '#FFA066' }, 
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
            
          }}
        >
          <Button
            variant="outlined"
            startIcon={<Cancel />}
            onClick={() => setOpenCrop(false)}
            sx={{
              color: '#DC5D00', // Color del texto
              borderColor: '#DC5D00', // Color del borde
              '&:hover': {
                borderColor: '#DC5D00', // Color del borde al hacer hover
                backgroundColor: '#DC5D00', // Fondo al hacer hover (opcional)
                color: '#fff', // Cambia el color del texto cuando se hace hover
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            startIcon={<CropIcon />}
            onClick={cropImage}
            sx={{
              backgroundColor: '#DC5D00', // Color del fondo
              color: '#fff', // Color del texto
              borderColor: '#DC5D00', // Color del borde
              '&:hover': {
                backgroundColor: '#DC5D00', // Mantiene el mismo color al hacer hover
                borderColor: '#DC5D00', // Mantiene el color del borde
                color: '#fff', // Mantiene el color del texto al hacer hover
              },
            }}
          >
            Crop
          </Button>
        </Box>
      </DialogActions>
    </>
  );
};

export default CropEasy;

